<template>
  <div>
    <div class="md-layout" v-if="false">
      <md-button class="md-dense md-primary" v-on:click="botao_voltar" v-if="botao_voltar_visible">
        <md-icon>arrow_back</md-icon>Voltar para lista
      </md-button>
    </div>
    <div class="md-layout" v-if="show_message == 'on' ">
      <div class="alert alert-success">{{message_text}}</div>
    </div>

    <div class="md-layout" v-if="loading">
      <div class="md-layout-item md-size-100">
        <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        {{msg_status}} ..
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">Dados do Documento</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <div class="md-layout" v-if="form.id != null">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">ID</label>
              <div class="md-layout-item md-size-15 md-xsmall-size-70" v-if="form.id != null">
                <md-field>{{form.id}}</md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Título</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <md-input name="titulo" type="text" placeholder="Título" v-model="form.titulo"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('titulo') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Descrição</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <md-textarea v-model="form.texto" name="texto" id="texto" style="height: 60px"></md-textarea>
                </md-field>

                <span class="error_input">{{ getErrors('texto') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente / Estabelecimento</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="sel_id_cliente"
                    :options="items_clientes"
                    v-model="form.id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    :onChange="loadUnidade"
                    :placeholder="placeholder_cliente"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Unidade</label>
              <div class="md-layout-item md-size-85 md-xsmall-size-70">
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select_unidade"
                    :options="items_unidade"
                    v-model="form.id_estabelecimento"
                    :searchable="true"
                    language="pt-BR"
                    :placeholder="placeholder_unidade"
                  ></vue_select>
                </md-field>

                <span class="error_input">{{ getErrors('id_estabelecimento') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Arquivo</label>
              <div class="md-layout-item md-size-65 md-xsmall-size-70">
                <md-field>
                  {{textUpload}}
                  <upload show_drop="0" :onGetFiles="getFiles" hide_button="1" v-if="show_upload"></upload>

                  <md-input
                    name="arquivo"
                    type="hidden"
                    placeholder="arquivo"
                    v-model="form.arquivo"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('arquivo') }}</span>
              </div>

              <div class="md-layout-item md-size-20 md-xsmall-size-100 btn-right" v-if="form.url_abrir != null">
                <a :href="form.url_abrir" target="_blank">
                  <md-button class="md-primary" type="button">Visualizar</md-button>
                </a>

                <a
                  style="cursor:pointer"
                  v-on:click="my_download(form.url_abrir, form.arquivo)"
                  target="_blank"
                >
                  <md-button class="md-primary" type="button">Baixar</md-button>
                </a>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">type</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input name="type" type="text" placeholder="type" v-model="form.type"></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('type') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">id_tabela</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_tabela"
                    type="text"
                    placeholder="id_tabela"
                    v-model="form.id_tabela"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_tabela') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Tamanho em bytes do arquivo.</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="tamanho"
                    id="tamanho"
                    v-bind:value="form.tamanho"
                    type="text"
                    placeholder="Tamanho em bytes do arquivo."
                    onkeypress="return obj_mask.Numerico(event, 2)"
                    style="width: 110px"
                  />
                </md-field>

                <span class="error_input">{{ getErrors('tamanho') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cliente / Estabelecimento</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_cliente"
                    type="text"
                    placeholder="Cliente / Estabelecimento"
                    v-model="form.id_cliente"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_cliente') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Unidade</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_estabelecimento"
                    type="text"
                    placeholder="Unidade"
                    v-model="form.id_estabelecimento"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_estabelecimento') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="form.id != null">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cadastrado em</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>{{form.data_cadastro | date_show}}</md-field>

                <span class="error_input">{{ getErrors('data_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="form.id != null">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Cadastrado por:</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  {{form.usuario_cadastro}}
                  <md-input
                    name="usuario_cadastro"
                    type="hidden"
                    placeholder="usuario_cadastro"
                    v-model="form.usuario_cadastro"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('usuario_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout" v-if="false">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">id_usuario_cadastro</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <md-input
                    name="id_usuario_cadastro"
                    type="text"
                    placeholder="id_usuario_cadastro"
                    v-model="form.id_usuario_cadastro"
                  ></md-input>
                </md-field>

                <span class="error_input">{{ getErrors('id_usuario_cadastro') }}</span>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-15 md-xsmall-size-30 md-form-label">Status</label>
              <div class="md-layout-item md-size-50 md-xsmall-size-70">
                <md-field>
                  <campo_status v-model="form.status"></campo_status>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-100">
        <div class="btn-right">
          <md-button
            class="md-info"
            type="button"
            v-bind:disabled="disableButton"
            v-on:click="salvar()"
          >Salvar</md-button>

          <botao_publicar :onClick="salvar" :disableButton="false" :status="form.status"></botao_publicar>

          <md-button
            class="md-danger"
            type="button"
            v-bind:disabled="disableButton"
            v-if="form != null && form.id != null && form.id !='' && parseInt(form.id) > 0"
            v-on:click="excluir()"
          >Excluir</md-button>
        </div>
      </div>

      <md-dialog :md-active.sync="showDialogError">
        <md-tabs md-dynamic-height>
          <md-tab md-label="Erros">
            <ul class="list-group" v-if="p_validator.errors != null ">
              <li
                v-for="(item, index) in p_validator.errors"
                class="list-group-item"
                :key="index"
                style="text-align: left"
              >{{item.msg}}</li>
            </ul>
            <center>
              <md-button class="md-danger" type="button" @click="hideModal">OK</md-button>
            </center>
          </md-tab>
        </md-tabs>
      </md-dialog>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/ArquivoClienteService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";

import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";

import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";

import serviceCliente from "../../../services/ClienteService";
import serviceEstabelecimento from "../../../services/EstabelecimentoService";

import Util from "../../../library/Util";
import Alerta from "../../../library/Alerta";

import upload from "../../components/images/upload.vue";
import swal from "sweetalert2";
import FileSaver from "file-saver";
import campo_status from "../../components/campo_status";
import botao_publicar from "../../components/botao_publicar";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    CardCadastro,
    vue_select,
    upload,
    campo_status,
    botao_publicar
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],

      show_perfil: false,
      file_upload: null,

      botao_voltar_visible: true,

      loading: true,

      result2: "",
      disableButton: false,

      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,

      msg_status: "Carregando",

      show_modal_contacts: false,
      show_sub_form: true,

      data_cadastro: null,

      language_date: ptBR,

      items_clientes: [],
      items_unidade: [],
      textUpload: "",
      id_cliente: null,
      montado: false,
      files: [],
      show_upload: true,

      placeholder_cliente: "..Carregando clientes",
      placeholder_unidade: "Selecione o cliente"
    };
  },
  watch: {
    id_cliente(val) {
      //      if ( this.montado ){
      //        this.loadUnidade();
      //   }
    }
  },
  mounted() {
    let self = this;

    let user = JSON.parse(window.obj_user.getUser());
    this.form = service.getModel();

    this.configureMessages();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    serviceCliente.getList2("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(
        response.data.data,
        "id",
        "nome"
      );
      self.placeholder_cliente = "Selecione o cliente (digite para pesquisar)";
    });

    this.disableButton = true;

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getById(this.id_load).then(function(response) {
        if (response.data.data != null && response.data.data != undefined) {
          self.form = response.data.data;
        } else {
          self.form = response.data.item;
        }
        if (self.form.data_cadastro != null) {
          var intData = self.getApiDateInt(self.form.data_cadastro);

          self.data_cadastro = new Date(intData);
        }
        setTimeout( () => self.loading = false, 100 );
        self.disableButton = false;
        self.id_cliente = self.form.id_cliente;
        self.montado = true;
        self.loadUnidade();

        if (
          self.form.status == 1 &&
          user.perfil.toLowerCase().indexOf("administrador") < 0 &&
          user.perfil.toLowerCase().indexOf("supervisor") < 0
        ) {
          self.disableButton = true;
        }
      });
    } else {
      this.loading = false;
      this.disableButton = false;
      self.montado = true;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "arquivo_cliente",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    my_download(url, arquivo) {
      console.log("File saver?");
      FileSaver.saveAs(url, arquivo);
    },

    getFiles(files) {
      this.files = files;
    },

    loadUnidade() {
      var self = this;

      console.log("unidade?");
      this.id_cliente = this.form.id_cliente;

      if (this.id_cliente == null) {
        self.items_unidade = [];
        self.placeholder_unidade = "Selecione o cliente";
        return false;
      }

      self.placeholder_unidade = "..Carregando unidades";
      serviceEstabelecimento
        .getListByParent("cliente", this.id_cliente)
        .then(function(response) {
          self.items_unidade = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );
          self.placeholder_unidade = "Unidades (digite para pesquisar)";
        });
    },

    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    configureMessages() {
      const dict = {
        // email: {
        //   required: 'O e-mail não pode ser vazio!',
        //   email: 'É necessário informar um e-mail válido!'
        // },
        titulo: {
          required: "Título não pode ser vazio!",
          internal: true
        },
        id_cliente: {
          required: "Selecione o cliente!",
          internal: true
        },
        id_estabelecimento: {
          required: "Selecione a unidade!",
          internal: true
        }

        // cnpj: {
        //   required: 'CPF/CNPJ não pode ser vazio!',
        // cpf: true //testará o método de CPF
        // }
      };

      this.setFieldsValidator(dict);

      //this.p_validator.localize('en', dict);
    },
    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },

    salvar(prop_status, prop_nome_perfil) {
      var self = this;

      this.form.id_cliente = this.id_cliente;

      if (!this.validar()) return false;

      if (this.files.length <= 0) {
        if (this.form.id == null) {
          Util.alerta(swal, "Atenção!", "Selecione  um arquivo!", null);
          return false;
        }
      }

      if (
        prop_status != null &&
        prop_status != undefined &&
        typeof prop_status == "number"
      ) {
        this.form.status = prop_status;
      }

      var data = {};

      //var data = new FormData();
      var qtde = 0;
      for (var x = 0; x < this.files.length; x++) {
        //data.append("file" + x, this.files[x]);
        data["file" + x] = this.files[x];
        qtde++;
      }
      if (this.form.id != null) {
        data["id"] = this.form.id;
      }
      data["file_qtde"] = qtde;
      data["id_cliente"] = this.form.id_cliente;
      data["id_estabelecimento"] = this.form.id_estabelecimento;
      data["titulo"] = this.form.titulo;
      data["texto"] = this.form.texto;
      data["status"] = this.form.status;

      console.log("Data?");
      console.log(data);

      self.msg_status = "Salvando..";
      self.loading = true;
      if (self.data_cadastro != null && self.data_cadastro != undefined) {
        //               self.data_cadastro = Util.dateToBd(  self.data_cadastro );
      }
      self.show_upload = false;

      console.log("Service?");
      console.log(data);
      service
        .salvar(data, this.progress)
        .then(function(response) {
          console.log("Response.data");
          console.log(response.data);
          var retorno = response.data;

          self.show_message = "on";
          self.message_text = "Documento do cliente salvo com sucesso!";

          self.interval_message = setInterval(self.clear_message, 6000);

          var item = retorno.item;

          self.msg_status = "Carregando..";
          self.loading = false;
          self.textUpload = "";

          self.form = item;
          self.files = [];
          self.show_upload = true;

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(retorno, "save");
          }
        })
        .catch(function(error) {});
    },

    excluir() {
      let self = this;

      if (self.form.id == null) return false;

      Alerta.confirm(
        "Atenção",
        "Deseja realmente excluir este documento ?",
        "question",
        function() {
          self.msg_status = "Excluindo..";
          self.loading = true;

          var fn_return = function(response) {
            var retorno = response.data;
            if (self.onSave != null && self.onSave != undefined) {
              self.onSave(retorno, "delete");
            }
            self.msg_status = "Carregando..";
            self.loading = false;
            self.botao_voltar();
          };

          service.delete(self.form.id).then(fn_return);
        },
        null
      );
    },
    progress(Percentage) {
      var self = this;

      this.textUpload = Percentage.toString() + "% enviado.";
      if (Percentage >= 100) {
        this.textUpload = "Envio concluído. Salvando documentos";

        // process completed
      }
    },

    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>